import { mapCreateApiUserResponseToDomain } from '@/domain/apiUsers/mappers';
import type {
    CreateApiUserVariables,
    CreatedApiUserResult,
    UseCreateApiUserResult,
} from '@/domain/apiUsers/types';
import type { DomainMutationOptions } from '@/domain/shared/types';
import { useClientController_createApiUser } from '@/services/hooks';
import type { CreateApiUserInput, CreateApiUserResponse } from '@/services/types';

type UseCreateApiUserOptions = DomainMutationOptions<
    {
        clientId: number;
        requestBody: CreateApiUserInput;
    },
    CreateApiUserResponse
>;

export const useCreateApiUser = (options?: UseCreateApiUserOptions): UseCreateApiUserResult => {
    const mutation = useClientController_createApiUser(options);

    const mutateAsync = async (
        variables: CreateApiUserVariables
    ): Promise<CreatedApiUserResult> => {
        const { clientId, requestBody } = variables;

        // Mapping Domain to API
        const requestBodyToSend: CreateApiUserInput = {
            accessLevelId: requestBody.accessLevelId || 1,
            allowedLocationIds: requestBody.allowedLocationIds || [],
            allowedCageIds: requestBody.allowedCageIds || [],
        };

        const result = await mutation.mutateAsync({ clientId, requestBody: requestBodyToSend });
        return mapCreateApiUserResponseToDomain(result.data);
    };

    return {
        ...mutation,
        isLoading: mutation.isPending,
        mutateAsync,
        data: mutation.data ? mapCreateApiUserResponseToDomain(mutation.data.data) : undefined,
    };
};
